import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
// @ts-nocheck
// tslint:disable
export var Event = /*#__PURE__*/_createClass(function Event(type, data) {
  _classCallCheck(this, Event);

  this.cancelBubble = false;
  this.cancelable = false;
  this.target = null;
  this.currentTarget = null;

  this.preventDefault = function () {// TODO
  };

  this.stopPropagation = function () {// TODO
  };

  this.type = type;
  this.timeStamp = Date.now();
});